/**
 * Shared Quick View engine, used by sections/collection.liquid,
 * sections/search.liquid, sections/product-list-v1.liquid, and
 * sections/recommended-products-v1.liquid via snippets/quick-view-modal.liquid.
 *
 * Each section calls window.EcQuickView.init({ sectionId, outerSelector, moneyFormat })
 * once its grid markup exists. init() is idempotent per outerSection (guarded via
 * a data attribute), so it's safe to call again on shopify:section:load.
 */
window.EcQuickView = (function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(val, defaultValue) { return val === undefined ? defaultValue : val; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  // Product JSON from /products/{handle}.js returns raw, un-resized Shopify
  // CDN URLs. Shopify's CDN honors a `width` query param on any asset URL
  // (the same mechanism the `image_url` Liquid filter uses), so we can still
  // get responsively-sized images here without a Liquid render round-trip.
  function resizeImage(url, width) {
    if (!url) return url;
    try {
      var resized = new URL(url, window.location.origin);
      resized.searchParams.set('width', width);
      return resized.toString();
    } catch (e) {
      return url;
    }
  }

  function init(options) {
    var sectionId = options.sectionId;
    var moneyFormat = options.moneyFormat || '${{amount}}';

    var outerSection = document.querySelector(options.outerSelector);
    var modal = document.getElementById('ec-pl-v1-modal-' + sectionId);
    var dynamicTarget = document.getElementById('ec-pl-v1-modal-dynamic-target-' + sectionId);
    if (!outerSection || !modal || !dynamicTarget) return;
    if (outerSection.dataset.ecQuickviewInit) return;
    outerSection.dataset.ecQuickviewInit = 'true';

    function refreshAndOpenCart() {
      if (window.ecCartDrawer && typeof window.ecCartDrawer.refreshCart === 'function') {
        window.ecCartDrawer.refreshCart();
      }
      if (window.ecCartDrawer && typeof window.ecCartDrawer.open === 'function') {
        window.ecCartDrawer.open();
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    var cachedProductPayloads = {};

    function closeQuickView() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderQuickViewDom(product) {
      var optionsMarkup = '';
      if (product.options && product.options[0].name !== 'Title') {
        product.options.forEach(function (option, optIdx) {
          optionsMarkup += '' +
            '<div class="ec-qv-option-group" data-option-index="' + optIdx + '">' +
              '<span class="ec-qv-option-name">' + option.name + '</span>' +
              '<div class="ec-qv-swatches">' +
                option.values.map(function (value, valIdx) {
                  var inputId = 'qv-opt-' + optIdx + '-' + valIdx + '-' + sectionId;
                  return '' +
                    '<div class="ec-qv-swatch-item">' +
                      '<input type="radio" id="' + inputId + '" name="qv-option-' + optIdx + '-' + sectionId + '" value="' + value.replace(/"/g, '&quot;') + '" class="ec-qv-swatch-input" ' + (valIdx === 0 ? 'checked' : '') + '>' +
                      '<label for="' + inputId + '" class="ec-qv-swatch-label">' + value + '</label>' +
                    '</div>';
                }).join('') +
              '</div>' +
            '</div>';
        });
      }

      var cleanDesc = product.description ? product.description.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 160) + '...' : '';

      dynamicTarget.innerHTML = '' +
        '<div class="ec-qv-shell">' +
          '<div class="ec-qv-gallery">' +
            '<div class="ec-qv-main-img-wrap">' +
              '<img id="ec-qv-master-img-' + sectionId + '" src="' + resizeImage(product.featured_image, 800) + '" alt="' + product.title + '">' +
            '</div>' +
            (product.images.length > 1 ? '' +
              '<div class="ec-qv-thumbs">' +
                product.images.map(function (img, i) {
                  return '<div class="ec-qv-thumb-node ' + (i === 0 ? 'is-active' : '') + '" data-src="' + resizeImage(img, 800) + '"><img src="' + resizeImage(img, 150) + '" alt="Preview thumbnail" loading="lazy"></div>';
                }).join('') +
              '</div>'
            : '') +
          '</div>' +
          '<div class="ec-qv-meta">' +
            (product.vendor ? '<span class="ec-qv-vendor">' + product.vendor + '</span>' : '') +
            '<h2 class="ec-qv-title">' + product.title + '</h2>' +
            '<div class="ec-qv-price-row">' +
              '<span class="ec-qv-price-current" id="ec-qv-node-price-' + sectionId + '">' + formatMoney(product.price, moneyFormat) + '</span>' +
              '<s class="ec-qv-price-compare" id="ec-qv-node-compare-' + sectionId + '"></s>' +
            '</div>' +
            '<div class="ec-qv-desc">' + cleanDesc + '</div>' +
            '<div class="ec-qv-variants-selectors">' + optionsMarkup + '</div>' +
            '<div class="ec-qv-quantity-box">' +
              '<span class="ec-qv-qty-label">Quantity</span>' +
              '<div class="ec-qv-qty-selector">' +
                '<button type="button" class="ec-qv-qty-btn" data-qty-change="minus" aria-label="Decrease quantity"><svg viewBox="0 0 24 24"><path d="M19 13H5v-2h14v2z"/></svg></button>' +
                '<input type="text" class="ec-qv-qty-input" value="1">' +
                '<button type="button" class="ec-qv-qty-btn" data-qty-change="plus" aria-label="Increase quantity"><svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg></button>' +
              '</div>' +
            '</div>' +
            '<div class="ec-qv-actions-console">' +
              '<button type="button" class="ec-qv-atc-submit" id="ec-qv-atc-' + sectionId + '">Add To Cart</button>' +
              '<button type="button" class="ec-qv-buynow-submit" id="ec-qv-buynow-' + sectionId + '">Buy Now</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      bindQuickViewInteractiveEngines(product);
    }

    function bindQuickViewInteractiveEngines(product) {
      var shell = dynamicTarget.querySelector('.ec-qv-shell');
      var mainImg = shell.querySelector('#ec-qv-master-img-' + sectionId);
      var thumbsContainer = shell.querySelector('.ec-qv-thumbs');
      var qtyInput = shell.querySelector('.ec-qv-qty-input');
      var atcBtn = shell.querySelector('#ec-qv-atc-' + sectionId);
      var buyNowBtn = shell.querySelector('#ec-qv-buynow-' + sectionId);

      if (thumbsContainer) {
        thumbsContainer.addEventListener('click', function (e) {
          var node = e.target.closest('.ec-qv-thumb-node');
          if (!node) return;
          thumbsContainer.querySelectorAll('.ec-qv-thumb-node').forEach(function (t) { t.classList.remove('is-active'); });
          node.classList.add('is-active');
          mainImg.setAttribute('src', node.getAttribute('data-src'));
        });
      }

      shell.querySelector('.ec-qv-qty-selector').addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-qty-change]');
        if (!trigger) return;
        var val = parseInt(qtyInput.value) || 1;
        if (trigger.getAttribute('data-qty-change') === 'plus') {
          val++;
        } else if (val > 1) {
          val--;
        }
        qtyInput.value = val;
      });

      function evaluateActiveSelectedVariant() {
        var chosenOptions = [];
        shell.querySelectorAll('.ec-qv-option-group').forEach(function (group) {
          var checkedRadio = group.querySelector('.ec-qv-swatch-input:checked');
          if (checkedRadio) chosenOptions.push(checkedRadio.value);
        });

        var matchedVariant = product.variants[0];
        if (chosenOptions.length > 0) {
          matchedVariant = product.variants.find(function (v) {
            return v.options.every(function (optValue, index) { return optValue === chosenOptions[index]; });
          });
        }

        var currentPriceNode = shell.querySelector('#ec-qv-node-price-' + sectionId);
        var comparePriceNode = shell.querySelector('#ec-qv-node-compare-' + sectionId);

        if (matchedVariant) {
          currentPriceNode.innerHTML = formatMoney(matchedVariant.price, moneyFormat);
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceNode.innerHTML = formatMoney(matchedVariant.compare_at_price, moneyFormat);
            comparePriceNode.style.display = '';
          } else {
            comparePriceNode.style.display = 'none';
          }

          if (matchedVariant.available) {
            atcBtn.removeAttribute('disabled');
            atcBtn.innerText = 'Add To Cart';
            buyNowBtn.removeAttribute('disabled');
            buyNowBtn.style.display = '';
          } else {
            atcBtn.setAttribute('disabled', 'disabled');
            atcBtn.innerText = 'Sold Out';
            buyNowBtn.setAttribute('disabled', 'disabled');
            buyNowBtn.style.display = 'none';
          }
        }
        return matchedVariant;
      }

      shell.addEventListener('change', function (e) {
        if (e.target.classList.contains('ec-qv-swatch-input')) {
          evaluateActiveSelectedVariant();
        }
      });

      var activeInitialVariant = evaluateActiveSelectedVariant();

      atcBtn.addEventListener('click', function () {
        var currentVariant = evaluateActiveSelectedVariant() || activeInitialVariant;
        if (!currentVariant) return;

        atcBtn.setAttribute('disabled', 'disabled');
        atcBtn.innerText = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentVariant.id, quantity: parseInt(qtyInput.value) || 1 })
        })
        .then(function (res) { return res.json(); })
        .then(function () {
          atcBtn.innerText = 'Added!';
          refreshAndOpenCart();
          setTimeout(function () { closeQuickView(); }, 800);
        })
        .catch(function () {
          atcBtn.removeAttribute('disabled');
          atcBtn.innerText = 'Error! Try Again';
        });
      });

      buyNowBtn.addEventListener('click', function () {
        var currentVariant = evaluateActiveSelectedVariant() || activeInitialVariant;
        if (!currentVariant) return;

        buyNowBtn.setAttribute('disabled', 'disabled');
        buyNowBtn.innerText = 'Redirecting...';

        var qty = parseInt(qtyInput.value) || 1;
        window.location.href = '/cart/' + currentVariant.id + ':' + qty;
      });
    }

    function triggerModalFetchAndOpen(handle) {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      dynamicTarget.innerHTML = '<div class="ec-pl-v1-modal-loading-shield"><div class="ec-spin"></div></div>';

      if (cachedProductPayloads[handle]) {
        renderQuickViewDom(cachedProductPayloads[handle]);
      } else {
        fetch('/products/' + handle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (product) {
            cachedProductPayloads[handle] = product;
            renderQuickViewDom(product);
          })
          .catch(function () {
            dynamicTarget.innerHTML = '<div style="padding:20px;text-align:center;font-size:14px;color:red;">Failed to load product.</div>';
          });
      }
    }

    outerSection.addEventListener('click', function (e) {
      var qvButton = e.target.closest('[data-action="quickview"]');
      var gridAtcBtn = e.target.closest('[data-action="grid-atc"]');
      if (!qvButton && !gridAtcBtn) return;

      var card = e.target.closest('[data-product-handle]');
      if (!card) return;

      var handle = card.getAttribute('data-product-handle');
      var hasOptions = card.getAttribute('data-has-options') === 'true';

      if (qvButton || (gridAtcBtn && hasOptions)) {
        triggerModalFetchAndOpen(handle);
      } else if (gridAtcBtn && !hasOptions) {
        var variantId = gridAtcBtn.getAttribute('data-variant-id');
        if (!variantId) return;

        gridAtcBtn.setAttribute('disabled', 'disabled');
        var originalText = gridAtcBtn.innerText;
        gridAtcBtn.innerText = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (res) { return res.json(); })
        .then(function () {
          gridAtcBtn.innerText = 'Added!';
          refreshAndOpenCart();
          setTimeout(function () {
            gridAtcBtn.removeAttribute('disabled');
            gridAtcBtn.innerText = originalText;
          }, 1200);
        })
        .catch(function () {
          gridAtcBtn.removeAttribute('disabled');
          gridAtcBtn.innerText = 'Error!';
          setTimeout(function () { gridAtcBtn.innerText = originalText; }, 1200);
        });
      }
    });

    modal.querySelectorAll('[data-close-modal]').forEach(function (trigger) {
      trigger.addEventListener('click', closeQuickView);
    });
  }

  return { init: init, formatMoney: formatMoney };
})();
